import errorHandler from './error-handler'
import closeReport from './read-only-mode-handler'
import language from './language'
import rtl from './rtl'

export default [errorHandler, closeReport, language, rtl]
